// extracted by mini-css-extract-plugin
export var actionButton = "_ku-0";
export var actionMenuContainer = "_ku-i";
export var bubble = "_ku-2";
export var bubbleActionMenu = "_ku-j";
export var bubbleContext = "_ku-6";
export var bubbleItems = "_ku-7";
export var customer = "_ku-3";
export var divider = "_ku-8";
export var fileList = "_ku-9";
export var hiddenComment = "_ku-o";
export var infoAbove = "_ku-a";
export var internal = "_ku-4";
export var lightActionButton = "_ku-1";
export var link = "_ku-b";
export var merchant = "_ku-5";
export var message = "_ku-c";
export var profilePicture = "_ku-e";
export var quillToolbarContainer = "_ku-f";
export var senderDate = "_ku-g";
export var senderDateCustomer = "_ku-h";
export var senderName = "_ku-d";
export var time = "_ku-k";
export var uploadedImage = "_ku-l";
export var username = "_ku-m";
export var xsmall = "_ku-n";